<template>
<div>

    <v-card class="ma-2">
        <v-card-title class="teal white--text">
            Sertifikat
            <v-spacer />
            <v-btn v-if="!readonly" @click.stop="openForm(null)"> <v-icon left>add</v-icon>Tambah</v-btn>
        </v-card-title>

        <v-data-table class="elevation-1" :headers="table.headers" :items="table.items">
            <template v-slot:item.noSertifikat="{item}">
                {{ item.noSertifikat }}
                <v-btn icon @click="getLinkDownload(item.fileSertifikat)"><v-icon color="green">get_app</v-icon></v-btn>
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn icon @click="openForm(item, true)"><v-icon small color="cyan">mdi-file</v-icon></v-btn>
                <v-btn v-if="!readonly" icon @click="openForm(item, false)"><v-icon small color="cyan">mdi-pencil</v-icon></v-btn>
                <v-btn v-if="!readonly" icon @click="deleteConfirmation(item)"><v-icon small color="red">mdi-delete</v-icon></v-btn>
            </template>
        </v-data-table>
    </v-card>

    <v-dialog v-model="form.isShowing" max-width="512" persistent>
        <v-form ref="form" lazy-validation>
            <v-card>
                <v-card-title class="teal white--text">Sertifikat</v-card-title>

                <v-container>
                    <v-row dense> <v-col> <v-text-field label="Keahlian" v-model="form.data.keahlian" outlined :rules="[rules.required]" :readonly="form.isReadOnly" /> </v-col> </v-row>
                    <v-row dense> 
                        <v-col> <v-text-field label="No. Sertifikat" v-model="form.data.noSertifikat" outlined :rules="[rules.required]" :readonly="form.isReadOnly" /> </v-col> 
                    </v-row>
                    <v-row>
                        <v-col> 
                            <v-file-input 
                                label="File Sertifikat" 
                                v-model="form.uploadFileSertifikat" 
                                :placeholder="form.data.fileSertifikat" 
                                accept=".jpg,.png,.pdf" 
                                :append-icon="form.data.fileSertifikat !== '' ? 'get_app' : ''"
                                @click:append="getLinkDownload(form.data.fileSertifikat)" 
                                :rules="[validateFileSertifikat()]"
                                :disabled="form.isReadOnly"
                            />
                        </v-col> 
                    </v-row>
                </v-container>

                <v-card-actions>
                    <v-btn v-if="!form.isReadOnly" color="green" dark @click="submitForm()">Simpan</v-btn>
                    <v-btn color="cyan" dark @click="closeForm()">Tutup</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>

    <!-- Notification -->
    <v-snackbar
        v-model="notification.show"
        :color="notification.color"
        :top="true"
        :right="true"
        :timeout=3000
    >
        {{ notification.text }}
    </v-snackbar>

    <!-- Delete confirmation -->
    <v-dialog v-model="form.isDeleting" max-width="600" persistent>
        <v-card dark>
            <v-card-title>Hapus data sertifikat?</v-card-title>
            <v-card-actions>
                <v-btn color="red" @click="deleteData()">Hapus</v-btn>
                <v-btn color="cyan" @click="closeForm()">Batal</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog v-model="loginExpired" max-width="400" persistent>
        <v-card>
            <v-card-title>[401] Login Expired</v-card-title>
                <v-card-text>Silakan Login Ulang</v-card-text>
            <v-card-actions>
                <v-btn color="red" @click="logoutClick()">Ya</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>


<script>

const apiUrl = process.env.VUE_APP_ROOT_API
import axios from 'axios'
import { rules as Rules } from './../../lib/rules'


export default {
    props: {
        vendorId: {
            type: Number,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            rules: {
                required: Rules.required
            },

            table: {
                headers: [
                    { text: "Keahlian", value: "keahlian", class: "blue lighten-2 subtitle-2 font-weight-bold" },
                    { text: "No. Sertifikat", value: "noSertifikat", class: "blue lighten-2 subtitle-2 font-weight-bold" },
                    { text: "Actions", value: "actions", class: "blue lighten-2 subtitle-2 font-weight-bold", sortable: false },
                ],
                items: []
            },

            form: {
                data: {
                    id: -1,
                    keahlian: "",
                    noSertifikat: "",
                    fileSertifikat: ""
                },
                uploadFileSertifikat: null,
                isShowing: false,
                isReadOnly: false,
                isEditing: false,
                isDeleting: false,
                everOpened: false,
            },

            notification: {
                show: false,
                color: "success",
                text: ""
            },

            submitting: false,
            loginExpired: false
        }

    }, // data


    watch: {
        vendorId() {
            this.getData();
        }
    },


    mounted() {
        this.getData();
    }, // mounted


    methods: {
        getData() {
            this.table.items = [];

            axios.get(`${apiUrl}/vendor/person/sertifikat/${this.vendorId}`)
            .then( (response) => {
                this.table.items = response.data;
            }).catch( (error) => {
                console.error(error);
                if(error.response.status == 401) {
                    this.loginExpired = true;
                }else {
                    this.notification = {
                        show: true,
                        color: "error",
                        text: `Gagal mengambil data [${error.message}]`
                    };
                }
            });
        },

        getLinkDownload(dok) {
            axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = dok
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },

        validateFileSertifikat() {
            if (this.form.data.fileSertifikat !== "") return true;
            return this.form.uploadFileSertifikat != null || "Harap melampirkan file sertifikat";
        },

        resetForm() {
            this.form.data = {
                id: -1,
                keahlian: "",
                noSertifikat: "",
                fileSertifikat: ""
            };

            this.form.uploadFileSertifikat = null;

            if (this.form.everOpened) {
                this.$refs.form.reset();
            }
        },

        openForm(sertifikat, isReadOnly) {
            this.resetForm();

            if (sertifikat) {
                this.form.data = Object.assign({}, sertifikat);
                this.form.isEditing = true;
            }

            this.form.isShowing = true;
            this.form.isReadOnly = isReadOnly;
            this.form.everOpened = true;
        },

        closeForm() {
            this.resetForm();
            this.form.isShowing = false;
            this.form.isEditing = false;
            this.form.isDeleting = false;
        },

        submitForm() {
            if (!this.$refs.form.validate()) return;

            let fdata = new FormData();
            fdata.append("id", this.form.data.id);
            fdata.append("vendorId", this.vendorId);
            fdata.append("keahlian", this.form.data.keahlian);
            fdata.append("noSertifikat", this.form.data.noSertifikat);
            fdata.append("fileSertifikat", this.form.uploadFileSertifikat);

            this.submitting = true;

            axios.post(`${apiUrl}/vendor/person/sertifikat`, fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
            .then( (response) => {
                const sertifikat = response.data;
                const index = this.table.items.findIndex(check => check.id === sertifikat.id);

                if (index != -1) {
                    this.table.items.splice(index, 1, sertifikat);
                }
                else {
                    this.table.items.push(sertifikat);
                }

                this.notification = {
                    show: true,
                    color: "success",
                    text: "Data sertifikat berhasil disimpan"
                };

                this.closeForm();

            }).catch( (error) => {
                console.error(error);
                if(error.response.status == 401) {
                    this.loginExpired = true;
                }else if(error.response.status == 422) {
                    this.loginExpired = true;
                }else {
                    this.notification = {
                        show: true,
                        color: "error",
                        text: `Gagal simpan data sertifikat [${error.message}]`
                    };
                }

            }).finally( () => {
                this.submitting = false;

            });

        },

        deleteConfirmation(sertifikat) {
            this.form.data = sertifikat;
            this.form.isDeleting = true;
        },

        deleteData() {
            if (this.form.data.id === -1) return;

            this.submitting = true;

            axios.delete(`${apiUrl}/vendor/person/sertifikat/${this.form.data.id}`)
            .then( (response) => {
                console.log("PersonSertifikat:deleteData()-response: ", response.data);
                const index = this.table.items.findIndex(check => check.id === this.form.data.id);

                if (index != -1) {
                    this.table.items.splice(index, 1);
                }

                this.notification = {
                    show: true,
                    color: "success",
                    text: "Data sertifikat berhasil dihapus"
                };

                this.closeForm();

            }).catch( (error) => {
                console.error(error);
                if(error.response.status == 401) {
                    this.loginExpired = true;
                }else if(error.response.status == 422) {
                    this.loginExpired = true;
                }else {
                    this.notification = {
                        show: true,
                        color: "error",
                        text: `Gagal hapus data sertifikat [${error.message}]`
                    };
                }

            }).finally( () => {
                this.submitting = false;

            });
        },
        logoutClick: function() {
            this.$store.dispatch('logout')
            .then(() => {
                this.$router.push('/')
            })
        },

    }, // methods
}

</script>
